
import { Component, Vue, Prop } from 'vue-property-decorator'
import { IOrderObject } from '@/types/orderDetail'
import { IConfig } from '@/types/placeOrderTypes'

@Component
export default class OrderDetail extends Vue {
  @Prop({ type: Boolean, default: false }) visible!: boolean
  @Prop({ type: Object, default: null }) order!: IOrderObject | null
  @Prop({ type: Array, default: () => [] }) subjects!: any[]
  @Prop({ type: Array, default: () => [] }) stages!: any[]

  handleClose() {
    this.$emit('update:visible', false)
    this.$emit('close')
  }

  openConfig(config: IConfig) {
    this.$emit('open-config', config)
  }
}
